<script>
    import {Link, navigate} from 'svelte-routing';
    import {store} from '../stores.js';
    import Image from '../components/Image.svelte';

    const user = store('credentials', 'appUserAuth'),
          user_loading = user.loading();
    
    // credentials
    let login = ($user.email ? $user.email : ''),
        password = ($user.pasport ? $user.pasport : ''),
        error = false;
    
    const handlerClick = async () => {
        if (login && password) {
            let result = await user.load({login, password});
    
            if (result.id > 0 ) {
                if (location.search.includes('?ev=')) {
                    navigate('/events/view/' + location.search.replace('?ev=', ''));
                } else {
                    navigate('/dashboard');
                }
            } else if (result.idRegPred > 0 ) {
                navigate('/panel');
            } else {
                error = true;
                setTimeout(() => error = false, 3000);
            }
        }
    };
    const onKeyPress = (e) => {
        if (e.charCode === 13) handlerClick();
    };
</script>

<div id="appCapsule">
    <div class="login-form mt-1">
        <div class="section">
            <Image src="/img/vector4.png" alt="image" class="form-image" />
        </div>
        <div class="section mt-1">
            <h1>Вход</h1>
            <h4>Заполните форму для входа</h4>
        </div>
        <div class="section mt-1 mb-5">
            <form>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <input type="text" class="form-control" name="login" style="{error ? 'border: 1px solid red;' : ''}" bind:value={login} placeholder="E-Mail или телефон">
                    </div>
                </div>
                <div class="form-group boxed">
                    <div class="input-wrapper">
                        <input type="password" class="form-control" name="password" style="{error ? 'border: 1px solid red;' : ''}" bind:value={password} on:keypress={onKeyPress} placeholder="Пароль" autocomplete="off">
                    </div>
                </div>
                <div class="form-links mt-2">
                    <div></div>
                    <div><Link to="/forgot" class="text-muted">Забыли пароль?</Link></div>
                </div>
    
                <div class="form-button-group">
                    <button type="button" class="btn btn-primary btn-block btn-lg" on:click={handlerClick} disabled={$user_loading}>
                        {#if $user_loading}Входим{:else}Вход{/if}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
